import type { GetStaticPaths, GetStaticProps } from 'next'
import type { FC } from 'react'
import type { Category, Product } from '@/types'

import { Seo } from '@/components/generals/seo'
import { SiteLayout } from '@/components/layout/site-layout'

import {
    GoldCta,
    ProductList,
    ProductsHero,
    SortDropdown
} from '@/components/products'

import { getLayoutData } from '@/lib/layout-data'

import {
    getCategories,
    getCategoryBySlug,
    getProductsByCategorySlug
} from '@/lib/collections'

interface CategoryPageProps {
    category: Category
    products: Product[]
    categories: Category[]
}

const DESCRIPTION =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Netus gravida odio sagittis, risus sodales nec. Sagittis nisi at venenatis, pretium. Risus neque a, egestas iaculis.'

const CategoryPage: FC<CategoryPageProps> = ({ category, products, categories }) => {
    return (
        <SiteLayout categories={categories}>
            <Seo title={category.name} description={DESCRIPTION} ogImage={category.image} />

            <div className='section'>
                <div className='container'>
                    <ProductsHero
                        variant='category'
                        title={category.name}
                        description={DESCRIPTION}
                        contentId='w-node-e917f83e-203e-2ef7-ceea-9cfb85a0f025-f25bd842'
                    />

                    <SortDropdown
                        categories={categories}
                        label={category.name}
                        activeSlug={category.slug}
                        semiBold
                    />
                </div>
            </div>

            <ProductList products={products} />

            <GoldCta />
        </SiteLayout>
    )
}

export const getStaticPaths: GetStaticPaths = async () => ({
    paths: getCategories().map((category) => ({ params: { slug: category.slug } })),
    fallback: false
})

export const getStaticProps: GetStaticProps<CategoryPageProps> = async ({ params }) => {
    const slug = params?.slug as string
    const category = getCategoryBySlug(slug)

    if (!category) return { notFound: true }

    const { categories } = getLayoutData()

    return {
        props: {
            category,
            products: getProductsByCategorySlug(slug),
            categories
        }
    }
}

export default CategoryPage
